import PromotedGames from "./PromotedGames";

export default PromotedGames;